(function() {
  "use strict";

  angular.module("PrintixNavigationBar", [])

    .constant("PrintixNavigationBarConstantsURLS", {
      NAV_BAR_ITEMS: "assets/jsonFiles/quickAccess/quickAccessItems.json"
    })

    .controller("NavigationBarController", [
      "$rootScope", "$scope", "Utils", "PrintixNavigationBarConstantsURLS","URLS", "$http", "$injector",
      "$location", "toastr", "EventServiceEvents", "$filter", '$timeout',
      function(
        $rootScope, $scope, Utils, PrintixNavigationBarConstantsURLS, URLS, $http, $injector,
        $location, toastr, EventServiceEvents, $filter, $timeout) {

        $scope.me = $rootScope.currentUser;
        $scope.tenant = null;
        $scope.maxButtonsAllowed = 9;
        $scope.urls = URLS;
        $scope.quickAccessButtonsList = [];
        $scope.requiredButtonItemProperties = ["icon", "url"];
        $scope.runningTask = null;
        $scope.ongoingGroupSync = false;

        $scope.singInMehtods = {
          LOCAL_AD: 'AD',
          AZURE: 'Microsoft',
          EMAIL: $filter('translate')('Email'),
          GOOGLE: 'Google',
          OKTA: 'Okta',
          ONELOGIN: 'OneLogin',
          VERTICAL: 'Vertical',
          client_credentials: 'API',
          KIOSK: 'Kiosk',
          OIDC: 'OIDC'
        };

        $scope.showSubscribeButton = false;
        $scope.todoMap = {};

        (function() {
          setListeners()
          checkPath();
        })();

        var TenantListService = $injector.get("TenantListService");
        try {
          var watch = $scope.$watch(function() {
            return TenantListService.currentTenant;
          }, function() {
            if (TenantListService.currentTenant) {
              $scope.tenant = TenantListService.currentTenant;
              if (!$scope.quickAccessButtonsList || $scope.quickAccessButtonsList.length < 1) {
                $scope.getQuickAccessItems();
              }
              watch();
              checkForRunningTasks()
              checkTodoList()
              watchTheTodos()
            }
          }, true);
        } catch (e) {}

        function checkTrialStatus() {
          var subscriptionStatus = TenantListService.currentTenant.info._embedded.subscriptionStatus.status;

          switch(subscriptionStatus) {
            case 'EXPIRE_AFTER_TRIAL':
            case 'IN_TRIAL':
              if (Object.keys(TenantListService.currentTenant.info.todoMap).length === 0) {
                if (!TenantListService.currentTenant.info._links['px:salesPartner']) {
                  $scope.showSubscribeButton = true;
                } else {
                  $scope.showSubscribeButton = false;
                }
              } else {
                $scope.showSubscribeButton = false;
              }
            break;
            case 'DEACTIVATED':
            case 'DELETED':
            case 'SUBSCRIBE_AFTER_TRIAL':
            case 'NOT_FOR_RESALE':
            case 'SUBSCRIBED':
            case 'UNKNOWN':
              $scope.showSubscribeButton = false;
            break;
          }
        }


        function checkTodoList () {
          $scope.todoMap = TenantListService.currentTenant.info.todoMap;
          checkTrialStatus();
        }

        function watchTheTodos () {
          $scope.$watch(function () {
            return TenantListService.currentTenant.info._embedded.toDos
          }, function (val1, val2) {
            if (val1 !== val2) {
              $timeout(() => {
                checkTodoList();
              },6000)
            }
          })

        }


        function checkForRunningTasks () {
          if ($scope.tenant.info && $scope.tenant.info._embedded.progressingTasks && $scope.tenant.info._embedded.progressingTasks.length > 0) {
            angular.forEach(TenantListService.currentTenant.info._embedded.progressingTasks, function(task) {
              var progressFound = false;

              if (!task.systemTask && task._embedded.progress && task._embedded.progress.length > 0) {
                angular.forEach(task._embedded.progress, function(taskProgress) {
                  if (taskProgress.target > taskProgress.current) {
                    progressFound = true;
                  }
                });
              }

              if (progressFound) {
                $scope.runningTask = task;
              } else {
                $scope.runningTask = null;
              }
            });
          }

        }

        $scope.$watch(function(){
          return $rootScope.synchronizingGroupsIsOngoing;
        }, function(){
          if ($rootScope.synchronizingGroupsIsOngoing) {
            $scope.ongoingGroupSync = $rootScope.synchronizingGroupsIsOngoing;
          }
        }, true);



        function updateGroupSyncSubTaskIds(data) {
          if ($rootScope.synchronizingGroupsIsOngoingSubTaskIds) {
            for (var i = 0; i < $rootScope.synchronizingGroupsIsOngoingSubTaskIds.length; i++) {
              if ($rootScope.synchronizingGroupsIsOngoingSubTaskIds[i] === data.taskId) {
                if (data.status === 'COMPLETED') {
                  $rootScope.synchronizingGroupsIsOngoingSubTaskIds.splice(i, 1);
                }
              }
            }
          }

          if ($rootScope.synchronizingGroupsIsOngoingSubTaskIds && $rootScope.synchronizingGroupsIsOngoingSubTaskIds.length < 1) {
            $scope.ongoingGroupSync = false;
            $rootScope.synchronizingGroupsIsOngoing = false;
          }
        }

        $scope.addButtonItemToButtonItemsSuccessCallback = function(response) {
          $scope.quickAccessButtonsList = [];
          angular.forEach(response.data, function(buttonItem) {
            if (Utils.objectPropertiesCheck(buttonItem, $scope.requiredButtonItemProperties)) {
              if (typeof buttonItem.show !== "boolean") {
                buttonItem.showResult = Utils.evalJs(buttonItem.show);
              }  else {
                buttonItem.showResult = angular.copy(buttonItem.show);
              }
              $scope.quickAccessButtonsList.add(buttonItem);
            } else {
            }
          });
        };

        $scope.getQuickAccessItems = function() {
          $http.get(PrintixNavigationBarConstantsURLS.NAV_BAR_ITEMS, {
            cache: true
          }).then($scope.addButtonItemToButtonItemsSuccessCallback).catch(function(error){});
        };

        $scope.$on("$locationChangeStart", function() {
          delete $rootScope.secondaryHeadline;
        });

        $scope.$watch(function(){
          return $rootScope.currentUser;
        }, function(){
          if ($rootScope.currentUser) {
            $scope.me = $rootScope.currentUser;
            setUser()
          }
        }, true);

        function setUser () {
          $scope.name = $rootScope.currentUser.info._embedded.user.name;
          $scope.role = $rootScope.currentUser.info._embedded.permissions.role;
          $scope.signInMethod = $filter('translate')($scope.singInMehtods[$rootScope.currentUser.info._embedded.authentication_details.source]);
        }

        $scope.$watch(function() {
          return $location.path();
        }, function() {
          checkPath();
        }, true);

        function checkPath () {

          var path = $location.path()
          if (path.indexOf('/sites') > -1) {
            $scope.path = '#/sites'
          } else {
            $scope.path = '#' + path;
          }

        }

        $scope.gotoUser = function() {
          $location.path('/userProperties/' + $rootScope.currentUser.customProperties.id);
        }

        $scope.gotoSetup = function () {
          $location.path('/setup');
        }

        $scope.gotoAuthentication = function () {
          $location.path('/authentication').search({'authenticationSection': 'setup', 'todo': 'setup_auth'});
        }

        $scope.gotoImplementation = function () {
          $location.path('/implementationAssistant').search({'todo': 'add_user'});
        }

        $scope.gotoSubscribtion = function () {
          $location.path('/subscription');
        }

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // TOOLTIP STUFF
        ////////////////////////////////////////////
        $scope.showTooltip = function (showTip, position, tooltipScope, context) {
          if (showTip) {
            switch(tooltipScope) {
              case 'site':
                siteTooltip(position, context);
              break;
            }
          } else {
            $scope.clearTooltip();
          }
        }

        function siteTooltip (position, title) {

          $scope.clearTooltip();
          $scope.tooltipContent = {
            title: title,
            type: 'statement',
          }

          $scope.tooltipObject = {
            position: {left: position.startX, top: position.startY + 20}
          }
        }

        $scope.clearTooltip = function () {
          $scope.tooltipContent = null;
          $scope.tooltipObject = null;
        }

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // LISTENERS
        ////////////////////////////////////////////
        function setListeners () {
          $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.GROUPS_SYNCHRONIZATION_COMPLETE, function(name, data) {
            updateGroupSyncSubTaskIds(data);
          });


          $scope.$on('CHECK_TODO_LIST', function() {
            checkTodoList()
          })
        }
      }
    ]);
})();
